/* global SWDLocalise */
import { handleResponse, loaderHTML } from '../../utils';

let searchInstance;
let isLoading = false;
const searchForm = document.querySelector('.js-vrm-search');

const disableLoader = () => {
    searchForm.querySelectorAll('.js-loader').forEach((el) => el.remove());
    isLoading = false;
};

const enableLoader = () => {
    if (isLoading) return;

    const response = searchForm.querySelector('.js-vrm-search-response');
    if (response) response.remove();

    searchForm.insertAdjacentHTML('beforeend', loaderHTML);
    isLoading = true;
};

const buildForms = (data) => (`
    <div class="pt-8 pb-6 px-8 mt-2 border-2 border-light rounded-lg js-vrm-search-response">
        <h2 class="mb-2 text-2xl/tight font-semibold">${data.manufacturer} - ${data.model}</h2>
        <p class="mb-6">Search for front or rear tyres for vehicle ${data.model}</p>
        <div class="sm:flex justify-center">
            <form
                action="${data.action}"
                method="get">
                <input
                    type="hidden"
                    name="section"
                    value="${data.front.section}">
                <input
                    type="hidden"
                    name="profile"
                    value="${data.front.profile}">
                <input
                    type="hidden"
                    name="rim"
                    value="${data.front.rim}">
                <input
                    type="hidden"
                    name="vrm"
                    value="${data.vrm}">
                ${data.front.runflat === true ? '<input type="hidden" name="runflat" value="true">' : ''}
                <button
                    type="submit"
                    class="w-full sm:w-min h-14 mb-2 sm:ml-1.5 px-8 border-2 border-grey-light bg-grey-light rounded-lg text-center font-semibold select-none touch-manipulation whitespace-nowrap transition-colors hover:bg-green hover:border-green hover:text-white${searchForm.dataset.inline ? ' js-vrm-search-inline-btn' : ''}"
                    data-tyre="front">Search Front Tyres</button>
            </form>
            <form
                action="${data.action}"
                method="get">
                <input
                    type="hidden"
                    name="section"
                    value="${data.rear.section}">
                <input
                    type="hidden"
                    name="profile"
                    value="${data.rear.profile}">
                <input
                    type="hidden"
                    name="rim"
                    value="${data.rear.rim}">
                <input
                    type="hidden"
                    name="vrm"
                    value="${data.vrm}">
                ${data.rear.runflat === true ? '<input type="hidden" name="runflat" value="true">' : ''}
                <button
                    type="submit"
                    class="w-full sm:w-min h-14 mb-2 sm:ml-1.5 px-8 border-2 border-grey-light bg-grey-light rounded-lg text-center font-semibold select-none touch-manipulation whitespace-nowrap transition-colors hover:bg-green hover:border-green hover:text-white${searchForm.dataset.inline ? ' js-vrm-search-inline-btn' : ''}"
                    data-tyre="rear">Search Rear Tyres</button>
            </form>
        </div>
    </div>
`);

const buildErrorMessage = () => (`
    <div class="p-8 mt-2 border-2 border-light rounded-lg js-vrm-search-response">
        <h2 class="mb-2 text-2xl/tight font-semibold">Number Plate Registration Not Found</h2>
        <p>Unfortunately we cannot find tyre data for that vehicle number plate registration. Please check your entry or try searching using your car's make and model.</p>
    </div>
`);

const handleInlineBtns = (data) => {
    const searchResults = document.querySelector('.js-search-results');

    searchForm.querySelectorAll('.js-vrm-search-inline-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const position = btn.dataset.tyre;

            searchInstance.helper
                .clearRefinements()
                .toggleFacetRefinement('section', data[position].section)
                .toggleFacetRefinement('profile', data[position].profile)
                .toggleFacetRefinement('rim', data[position].rim);

            if (data[position].runflat === true) {
                searchInstance.helper.toggleFacetRefinement('runflat', true);
            }

            // preselect season
            if (searchResults
                && searchResults.dataset.season !== undefined) {
                searchInstance.helper
                    .clearRefinements('taxonomies.tyre_season')
                    .toggleFacetRefinement('taxonomies.tyre_season', searchResults.dataset.season);
            }

            // preselect type
            if (searchResults
                && searchResults.dataset.type !== undefined) {
                searchInstance.helper
                    .clearRefinements('taxonomies.tyre_type')
                    .toggleFacetRefinement('taxonomies.tyre_type', searchResults.dataset.type);
            }

            searchInstance.helper.search();

            // switch tab
            document.querySelector('.js-tab-btn').click();
        });
    });
};

const clickHandle = (event) => {
    event.preventDefault();

    enableLoader();

    const vrm = searchForm.querySelector('.js-vrm-search-input').value;
    if (vrm === '') {
        searchForm.insertAdjacentHTML('beforeend', buildErrorMessage());
        disableLoader();
        return;
    }

    const data = new FormData();
    data.append('action', searchForm.dataset.action);
    data.append('nonce', searchForm.dataset.nonce);
    data.append('vrm', vrm.toUpperCase().replace(' ', ''));

    fetch(SWDLocalise.ajaxUrl, {
        method: 'POST',
        cache: 'no-cache',
        body: data,
    })
        .then(handleResponse)
        .then((response) => {
            if (response.success) {
                searchForm.insertAdjacentHTML('beforeend', buildForms(response.data));

                if (searchForm.dataset.inline) handleInlineBtns(response.data);
            } else {
                searchForm.insertAdjacentHTML('beforeend', buildErrorMessage());
            }

            disableLoader();
        })
        .catch((error) => {
            console.error(error); // eslint-disable-line no-console
            searchForm.insertAdjacentHTML('beforeend', buildErrorMessage());
            disableLoader();
        });
};

const init = (search) => {
    if (!searchForm) return;

    searchForm.querySelector('.js-vrm-search-btn').addEventListener('click', clickHandle);

    searchInstance = search;
};

export default init;
